import React from 'react'
import './index.css'
import { fdiToPalmer, fdiSelectedSet } from '../../configTools/toothNumbering'

// Full 32-tooth chart for the printed order label.
//
// Plain numbers with a box around the selected ones; unselected teeth recede to grey. Shows
// EVERY tooth rather than listing only the selected ones the way the job cards do, so the
// height never depends on the selection and can never wrap onto a second sticker.
//
// The quadrant dividers are their OWN elements rather than borders on the edge cells. A border
// on the cell merges with that cell's selection box, so a selected tooth sitting against the
// midline swallowed the divider and the partition disappeared exactly where it matters most.
// Separate elements carry their own margin, so the gap survives any selection.
//
// Orientation is standard FDI: the patient's RIGHT is drawn on the LEFT.
//   quadrant 1 = upper right, 2 = upper left, 3 = lower left, 4 = lower right
// Note the lower arch is the mirror of the job cards', which place quadrant 3 bottom-left -
// a known defect there, not here.
const UPPER_FDI = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
const LOWER_FDI = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

const Index = ({ lineItems }) => {
    const selected = fdiSelectedSet(lineItems);

    const tooth = (fdi) => (
        <span
            key={fdi}
            className={'nv-lbl-tooth' + (selected.has(fdi) ? ' -on' : '')}
        >{fdiToPalmer(fdi)}</span>
    );

    // 8 teeth per quadrant; the split is what the vertical divider sits between.
    const row = (fdiList) => (
        <div className='nv-lbl-chart__row'>
            <span className='nv-lbl-chart__q'>{fdiList.slice(0, 8).map(tooth)}</span>
            <span className='nv-lbl-chart__vline'/>
            <span className='nv-lbl-chart__q'>{fdiList.slice(8).map(tooth)}</span>
        </div>
    );

    return (
        <div className='nv-lbl-chart'>
            <div className='nv-lbl-chart__sides'>
                <span>Right</span>
                <span>Left</span>
            </div>
            {row(UPPER_FDI)}
            <div className='nv-lbl-chart__hline'/>
            {row(LOWER_FDI)}
        </div>
    )
}

export default Index
